import { Alert, Snackbar } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { hideAgendaSnackbar } from 'stores/meeting';
import { agendaCardTextColor, agendaCardTitleColor } from '../../config';

const snackbarBgColor = agendaCardTitleColor;
const snackbarBorderColor = '#BFDBFE';

function GlobalAgendaSnackbar() {
  const dispatch = useDispatch();
  const { open, message, severity } = useSelector(
    (state) => state.meeting.agendaSnackbar
  );

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={() => dispatch(hideAgendaSnackbar())}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ zIndex: 99999 }}
    >
      <Alert
        onClose={() => dispatch(hideAgendaSnackbar())}
        severity={severity}
        variant="outlined"
        sx={{
          width: '100%',
          fontSize: '0.95rem',
          bgcolor: snackbarBgColor,
          color: agendaCardTextColor,
          borderColor: snackbarBorderColor,
          boxShadow: '0 4px 14px rgba(46, 181, 201, 0.22)',
          '& .MuiAlert-icon': {
            opacity: 1,
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default GlobalAgendaSnackbar;

